module.exports = __webpack_public_path__ + "static/media/github.45e3938d.svg";